import { Menu } from '@systemeio/components'
import type { ReactNode } from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

interface ActionMenuLinkItemProps {
  id: string
  dataTestAttributes?: Record<string, string>
  disabled?: boolean
  href: string
  isNext?: boolean
  label: ReactNode
  openInNew?: boolean
}

function actionMenuLinkItem({
  id,
  dataTestAttributes,
  disabled,
  href,
  label,
  openInNew,
}: ActionMenuLinkItemProps): Menu.LinkItemDefinition {
  return {
    id,
    type: 'link',
    disabled,
    label,
    render: (
      <LinkWithoutPrefetch
        {...dataTestAttributes}
        href={href}
        {...(openInNew ? { target: '_blank', rel: 'noreferrer' } : {})}
      />
    ),
  }
}

export { actionMenuLinkItem }
export type { ActionMenuLinkItemProps }
